module.exports = __webpack_public_path__ + "img/dopereview.ee80cd3a.png";